<template>
    <div>
        <point-write-link v-for="writeLayout in writeLayouts" :key="`pointComp${writeLayout}`"
                           :writeLayout="writeLayout" :pointData = "pointData"></point-write-link>
    </div>
</template>

<script>
import PointWriteLink from "@/components/point/PointWriteLink";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import pointUtil from "@/components/point/pointUtil";
import pointValidator from "@/mixins/validators/pointValidator";
export default {
    name: "PointWriteComponent",
    mixins: [alertMixins,pointUtil,pointValidator],
    components: {PointWriteLink},
    provide() {
        return {
            pointWriteSetData:this.setData
        }
    },
    inject: ['changeLoading'],
    props: {
        pointType: {default: ''},
        pointKey: {
            type: Number,
            default: () => {
                return 0
            }
        },
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            detailApiParamsSet: {},
            writeFunc:'',
            writeApiParamSet:{},
            writeSuccessType:1,
            parsingData:{},
            keyName: '',
            pointData: {},
            directUrl:'',
            directType:'',
            getFirst:false,
        }
    },
    created() {
        this.initConfig();
        if(this.pointKey !== 0 || this.getFirst ){

            this.getPoint();
        }else {

        this.initTemplateConfig()
        }
    },
    mounted() {
        EventBus.$on('writePoint',this.checkValidator)
    },
    beforeDestroy() {
        EventBus.$off('writePoint')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let configPoint = this.returnPointConfig(this.pointType);
            this.getFunc = configPoint.getFunc;
            this.detailApiParamsSet = configPoint.detailApiParamsSet
            this.writeFunc = configPoint.writeFunc
            this.writeApiParamSet = configPoint.writeApiParamSet
            this.writeSuccessType = configPoint.writeSuccessType
            this.parsingData = configPoint.parsingData
            this.keyName = configPoint.keyName
            this.directUrl = configPoint.directUrl
            this.directType = configPoint.directType
            this.getFirst = configPoint.getFirst
        },
        initTemplateConfig() {
            let configPoint = this.returnPointConfig(this.pointType);
            this.writeLayouts = configPoint.writeLayouts;
        },

        getPoint() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet))
            params[this.keyName] = this.pointKey
            try {
                this.$api.$point[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        this.createAlert({
                            title: '',
                            content: '데이터를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        });
                        return;
                    }
                    this.pointData = res.List[0]
                    this.initTemplateConfig()
                })
            } catch (e) {
                console.log(e)
            }

        },
        checkValidator(){
            let validatorArr = Object.keys(this.parsingData);
            this.$validate(validatorArr).then(success => {
                if (success) {
                    this.writePoint();
                } else {
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`);
                    })
                    this.errorAlert('입력 정보를 확인해주세요.');
                }
            })
        },
        writePoint(){
            this.changeLoading(true);
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet));
            util.Object.each(this.parsingData, (dataKey, apiKey, object) => {
                if (this.parsingData[dataKey] != '') {
                    params[this.parsingData[dataKey]] = this[dataKey];
                }
            })
            if (this.pointKey !== 0) {
                params.ibp_idx = this.pointKey;
            }
            if (this.itemKey !== 0) {
                params.i_idx = this.itemKey;
            }
            try {
                this.$api.$point[this.writeFunc](params).then(res => res.Data.Result).then(res => {

                    let result = false
                    if(this.getFirst){
                        result = res.Info.type === 1
                    }else {
                        result = res.List.Data.Status
                    }
                    if (!result) {
                        this.errorAlert('저장에 실패했습니다.');
                        this.changeLoading(false);
                        this.isRunning = false;
                        return false;
                    } else {
                        let key = 0;
                        if (this.pointKey != 0) {
                            key = this.pointKey;
                        }
                        this.afterFunc(key);

                    }
                })
            } catch (e) {
                this.changeLoading(false);
                this.isRunning = false;
                console.log(e);
            }
        },

        afterFunc(key){
            this.isRunning = false;
            this.changeLoading(false);
            let detailKey = key;
            this.createAlert(
                {
                    content: '저장되었습니다.',
                    btnText: '확인',
                    hide: () => {
                        if (this.directType === 'back') {
                            this.$router.back();
                            return false;
                        }
                        if(this.directType ==='modal'){
                            EventBus.$emit('getPointList')
                            this.$modal.hide(this.directUrl)
                            return false
                        }
                        if (this.directUrl === '') {
                            this.getPoint()
                            return false;
                        }

                        let url = this.directUrl;
                        if (this.directType === 'detail') {
                            url = url + detailKey;
                        }
                        this.$router.push(url);
                    }
                })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
